export const environment = {
  production: false,

  b2c_signUpSignIn_authority: 'https://login-test-suite360.afgonline.com.au/afgonlinetest.onmicrosoft.com/B2C_1A_SIGNIN',
  b2c_authorityDomain: 'https://login-test-suite360.afgonline.com.au',
  b2c_clientId: '102a963f-4c53-41ad-93df-71179ff189a1',
  b2c_scopes: {
    read: ["https://afgonlinetest.onmicrosoft.com/bf42710d-053f-6da8-dfac-77c1ab105cc5/tasks.read"], // scope exposed on comply365-webapi-poc application id
    write: ["https://afgonlinetest.onmicrosoft.com/bf42710d-053f-6da8-dfac-77c1ab105cc5/tasks.write"] // scope exposed on comply365-webapi-poc application id
  }
};
